var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "p-14" }, [
    !_vm.request
      ? _c(
          "div",
          [
            _c("EmptyListPlaceholder", {
              attrs: {
                title: "Your Resource does not have any description yet",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "image",
                    fn: function () {
                      return [_c("EmptyListImageRequests")]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                2557147869
              ),
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.request
      ? _c(
          "div",
          [
            _c("InfoDetailsWrapper", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "primary",
                    fn: function () {
                      return [
                        _c("div", { staticClass: "w-full flex" }, [
                          _c("div", { staticClass: "w-full" }, [
                            _c("table", { staticClass: "table-full w-full" }, [
                              _c("tbody", { staticClass: "w-full" }, [
                                _c("tr", { staticClass: "w-full" }, [
                                  _c("td", { staticClass: "w-full" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "grid grid-cols-7 gap-3 justify-center w-full",
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "col-span-3 text-left text-gray-500",
                                          },
                                          [_vm._v("Budget/Rate")]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass: "col-span-4 text-left",
                                          },
                                          [
                                            _vm._v(
                                              "$" +
                                                _vm._s(
                                                  _vm.getFormattedNumber(
                                                    _vm.request.min_budget
                                                  )
                                                ) +
                                                " - $" +
                                                _vm._s(
                                                  _vm.getFormattedNumber(
                                                    _vm.request.max_budget
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                                _c("tr", [
                                  _c("td", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "grid grid-cols-7 gap-3 justify-center w-full",
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "col-span-3 text-left text-gray-500",
                                          },
                                          [_vm._v("Duration")]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass: "col-span-4 text-left",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getFormattedDate(
                                                  _vm.request.from_date
                                                )
                                              ) +
                                                " - " +
                                                _vm._s(
                                                  _vm.getFormattedDate(
                                                    _vm.request.to_date
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                                _c("tr", [
                                  _c("td", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "grid grid-cols-7 gap-3 justify-center w-full",
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "col-span-3 text-left text-gray-500",
                                          },
                                          [_vm._v("Type")]
                                        ),
                                        _vm.request.tag
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "col-span-4 text-left",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.request.tag.name)
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "col-span-4 text-left",
                                              },
                                              [_vm._v("n/a")]
                                            ),
                                      ]
                                    ),
                                  ]),
                                ]),
                                _c("tr", [
                                  _c("td", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "grid grid-cols-7 gap-3 justify-center w-full",
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "col-span-3 text-left text-gray-500",
                                          },
                                          [_vm._v("Number")]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass: "col-span-4 text-left",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.request
                                                  .number_of_contractors
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                                _c("tr", [
                                  _c("td", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "grid grid-cols-7 gap-3 justify-center w-full",
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "col-span-3 text-left text-gray-500",
                                          },
                                          [_vm._v("Description")]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "col-span-4 text-left mr-3 h-40 overflow-y-auto scrollbar",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.request.description)
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "secondary",
                    fn: function () {
                      return [
                        _c("div", { staticClass: "ml-60" }, [
                          _c(
                            "div",
                            { staticClass: "w-full flex space-x-5 mb-3" },
                            [
                              _c("p", { staticClass: "text-gray-500" }, [
                                _vm._v("Requested by"),
                              ]),
                              _c("div", { staticClass: "flex" }, [
                                _c("div", { staticClass: "space-x-20" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-xs font-semibold inline-block py-1 px-2 rounded-full text-blue-600 bg-blue-200 last:mr-0 mr-1",
                                    },
                                    [
                                      _vm.request.created_by.avatar
                                        ? _vm._t(
                                            "image flex-shrink-0 span-fix mt-2.5",
                                            function () {
                                              return [
                                                _c("S3Image", {
                                                  class: [
                                                    _vm.defaultImageClasses,
                                                    _vm.avatarStyleClasses,
                                                  ],
                                                  attrs: {
                                                    s3FileKey:
                                                      _vm.request.created_by
                                                        .avatar,
                                                  },
                                                }),
                                              ]
                                            },
                                            {
                                              defaultClasses: [
                                                _vm.defaultImageClasses,
                                                _vm.avatarStyleClasses,
                                              ],
                                              image:
                                                _vm.request.created_by.avatar,
                                            }
                                          )
                                        : _vm._e(),
                                      !_vm.request.created_by.avatar
                                        ? _c(
                                            "span",
                                            {
                                              class: [
                                                _vm.defaultInitialsClasses,
                                                _vm.avatarStyleClasses,
                                              ],
                                              style: _vm.bgStyle,
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text-xs leading-none font-semibold text-white",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.request.created_by.given_name
                                                        .trimStart()[0]
                                                        .toUpperCase()
                                                    ) +
                                                      _vm._s(
                                                        _vm.request.created_by.family_name
                                                          .trimStart()[0]
                                                          .toUpperCase()
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.request.created_by.given_name
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.request.created_by.family_name
                                          ) +
                                          " "
                                      ),
                                    ],
                                    2
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                          _c("div", { staticClass: "w-full flex space-x-5" }, [
                            _c("p", { staticClass: "text-gray-500" }, [
                              _vm._v("Skills"),
                            ]),
                            _c(
                              "div",
                              { staticClass: "flex" },
                              _vm._l(_vm.request.skills, function (skill) {
                                return _c(
                                  "div",
                                  { staticClass: "space-x-20" },
                                  [
                                    _c("Chip", {
                                      staticClass: "bg-skillChip border-none",
                                      attrs: { chipContent: skill.skill.name },
                                    }),
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                          ]),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                true
              ),
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }